import {
  FilterMenuContextProvider,
  useIsInModal
} from '~/context/srp/FilterMenuContext';
import BedLength from './BedLength';
import BodyType from './BodyType';
import CabTypes from './CabTypes';
import ColorFacet from './Colors/ColorFacet';
import Cylinders from './Cylinders';
import Features from './Features';
import GreatDeals from './GreatDeals';
import MakeModel from './MakeModel';
import MPG from './MPG';
import Offering from './Offering';
import PaymentAndPrice from './PaymentAndPrice';
import SeatingCapacity from './SeatingCapacity';
import SimpleCheckboxList from './SimpleCheckboxList';
import Size from './Size';
import TowingCapacity from './TowingCapacity';
import Trim from './Trim';
import YearAndMileage from './YearAndMileage';

function FiltersMenu() {
  const isInModal = useIsInModal();

  return (
    <div
      data-testid={
        isInModal
          ? 'standardized-filters-menu-modal'
          : 'standardized-filters-menu'
      }
    >
      <Offering inModal />
      <PaymentAndPrice />
      <MakeModel />
      <Trim />
      <BodyType />
      <Size />
      <BedLength />
      <CabTypes />
      <TowingCapacity />
      <YearAndMileage />
      <GreatDeals />
      <SimpleCheckboxList filterKey="fuelTypes" title="Fuel Type" />
      <MPG />
      <Features />
      <ColorFacet facetKey="colors" />
      <ColorFacet facetKey="interiorColors" />
      <SeatingCapacity />
      <SimpleCheckboxList
        checkboxClassName="uppercase"
        filterKey="driveTypes"
        title="Drivetrain"
      />
      <SimpleCheckboxList filterKey="transmissions" title="Transmission" />
      <Cylinders />
    </div>
  );
}

type OwnProps = {
  inModal?: boolean;
};

export default function FilterMenuWrapper({ inModal = false }: OwnProps) {
  return (
    <FilterMenuContextProvider isInModal={inModal}>
      <FiltersMenu />
    </FilterMenuContextProvider>
  );
}
